import { lazy, Suspense } from 'react';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const ProviderMenuWrapper = /*#__PURE__*/lazy(() => import('./ProviderMenuWrapper'));
export const LazyProviderMenu = props => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INDEX_LOAD",
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(ProviderMenuWrapper, Object.assign({}, props))
    })
  });
};